import { IViewState, WorkbenchType } from './Interfaces';

export interface IWorkbenchState {
    selectedWorkbench: WorkbenchType;
    viewState: IViewState;
}

export const initialWorkbenchState: IWorkbenchState = {
    selectedWorkbench: WorkbenchType.QC,
    viewState: {
        latitude: -40,
        longitude: 174,
        zoom: 1,
    },
};
